import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import $ from 'jquery'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    channel: "maisy",
    channels: ["maisy", "refly", "emekare"],
    channelNames: { "maisy": "MAISY", "refly": "Re:Fly", "emekare": "エメ☆カレ" },
    eventNames: { "m": "MAISY", "r": "Re:Fly", "e": "エメ☆カレ" },
    dates: {
      "maisy": { "year": 2023, "month": 7, "date": 15, "day": "sat", "tomonth": "8", "todate": 6, "today": "sun" },
      "refly": { "year": 2023, "month": 7, "date": 15, "day": "sat", "tomonth": "8", "todate": 6, "today": "sun" },
      "emekare": { "year": 2023, "month": 7, "date": 15, "day": "sat", "tomonth": "8", "todate": 6, "today": "sun" },
    },
    music: { "maisy": "Yu（vague）", "refly": "伊 真吾（OVERCOME MUSIC）", "emekare": "大石憲一郎" },
    casts: {
      "maisy": [{ "cname": "光城新多", "aname": "きたつとむ", "img": "cut1_maisy.jpg" }, { "cname": "森重優那", "aname": "嶋崎裕道", "img": "cut2_maisy.jpg" }, { "cname": "愛澤 心", "aname": "大見洋太", "img": "cut3_maisy.jpg" }, { "cname": "黒曜 護", "aname": "結城伽寿也", "img": "cut4_maisy.jpg" }, { "cname": "神谷 祈", "aname": "藤希 宙", "img": "cut5_maisy.jpg" }, { "skip": true }, { "cname": "輝崎千紘", "aname": "今井俊斗", "img": "guest01_chihiro.jpg", "folder": "guest" }, { "cname": "天神陽人", "aname": "大久保 樹", "img": "cut4_emekare.jpg", "folder": "emekare" }, { "cname": "橋倉 杏", "aname": "坂下陽春", "img": "guest02_an.jpg", "folder": "guest" }, { "cname": "荒木 冴", "aname": "川上将大", "img": "guest03_sae.jpg", "folder": "guest" }],
      "refly": [{ "cname": "青柳 帝", "aname": "長塚拓海", "img": "cut1_refly.jpg" }, { "cname": "夜来立夏", "aname": "柊木智貴", "img": "cut2_refly.jpg" }, { "cname": "浮間志朗", "aname": "宮内伊織", "img": "cut3_refly.jpg" }, { "cname": "辺見 宙", "aname": "小椋涼介", "img": "cut4_refly.jpg" }, { "cname": "天橋幸弥<span class='kakko cosmo'>（コスモ）</span>", "aname": "吉澤 翼", "img": "cut5_refly.jpg" }, { "skip": true }, { "cname": "雅野 椿", "aname": "三原大樹", "img": "guest04_tsubaki.jpg", "folder": "guest" }, { "cname": "加賀谷 蓮", "aname": "野口友輔", "img": "guest05_ren.jpg", "folder": "guest" }, { "cname": "雨知祭利", "aname": "北原十希明", "img": "guest06_sairi.jpg", "folder": "guest" }, { "cname": "荒木 冴", "aname": "川上将大", "img": "guest03_sae.jpg", "folder": "guest" }],
      "emekare": [{ "cname": "雛瀬碧鳥", "aname": "白石康介", "img": "cut1_emekare.jpg" }, { "cname": "見明佐和", "aname": "正木 郁", "img": "cut2_emekare.jpg" }, { "cname": "小野屋あずき", "aname": "大友至恩", "img": "cut3_emekare.jpg" }, { "cname": "天神陽人", "aname": "大久保 樹", "img": "cut4_emekare.jpg" }, { "cname": "冠 嵐真", "aname": "安部 瞬", "img": "cut5_emekare.jpg" }, { "skip": true }, { "cname": "輝崎千紘", "aname": "今井俊斗", "img": "guest01_chihiro.jpg", "folder": "guest" }, { "cname": "美和 巴", "aname": "中三川歳輝", "img": "guest07_tomoe.jpg", "folder": "guest" }]
    },
    stories: { "maisy": "多くのスター声優を輩出してきた名門校「宝石が丘学園」に入学した幼馴染の「常に前向き＆一生懸命！」光城新多、「オーラが見えるスピリチュアル少年」黒曜 護、「おまじない好き男子」神谷 祈の3人は、学園のナンバー1パフォーマンスユニットを目指して路上パフォーマンスを始めるもなかなかうまくいかない。<br>ある日、見かねて飛び入り参加した「少女漫画を愛する純情ヤンキー」愛澤 心が彼らの窮地を救った。それ以来、新多は心をユニットに誘うもなかなかうまくいかない。<br>ようやく4人で活動を始めてみたものの、祈はあとから入った心を快く思っていない。そんな矢先、突如護が入院することに。2年から学園に編入してきた「元小劇団所属の実力派」森重優那は、護の願いを受けて仲間入りするが、彼には人に言えない秘密があり…<br>果たして5人は次々とくる試練を乗り越えて最高のパフォーマンスを見せることができるのか――。", "refly": "「宝石が丘学園」の問題児「頭脳派変態紳士」青柳 帝と「年齢不詳のミステリアス」コスモこと天橋幸弥は、これからも籍を置きたいなら5人組のユニットを作るよう学園から言われ、2人に巻き込まれた「頼りになる常識人」夜来立夏と共に急遽メンバーを募集。集まったのは「宇宙に憧れるロマンチスト」辺見 宙と「SNSが大好きなイマドキ男子」浮間志朗という中等部の2人。<br>ユニットのルールは3つ。ひとつ「お互いの仕事を邪魔しない」、ふたつ「お互いに寄りかからない」、みっつ「だれかひとりでも破ったら即解散」。<br>一見自立しているように見えるメンバー達だが、実はそれぞれ隠したい秘密を持っている。<br>彼らの秘密はじわじわとユニット活動に影響を与えていき…<br>彼らは本当の自分と向き合い、再スタートの道を見つけられるのか？", "emekare": "アイドル育成シミュレーションゲーム『エメラルド☆カレシ』のオーディションに合格した「低音ボイスの正統派アイドル」雛瀬碧鳥、「爽やかなみんなのお兄ちゃん」見明佐和、「自称騎士の筆談声優」小野屋あずき、「煌めき溢れる太陽声優」天神陽人、「夢を追いかける最強オタク」冠 嵐真の5人は、メインキャラクターの声優を担当しながら、2.5次元アイドル『エメ☆カレ』としても活動することに。<br>すでに決まっている劇場公演に向けて活動するも、大人たちが揉めてまともなレッスンもできないありさま。自分たちなりに頑張って迎えた初公演の観客は…ゼロ。日々試行錯誤を重ねて、やっと満員の日を迎えたが、新たな問題が発生。 <br>苦悩を抱えた5人は、仲間とファンと一緒に輝いていくことができるのか――。" },
    guest: { "maisy": "エメ☆カレ", "refly": "MAISY", "emekare": "Re:Fly" },
    guestUnitColor: { "maisy": "emekare", "refly": "maisy", "emekare": "refly" },
    news: [],
    endtime: 0,
    keyvisuals: { "maisy": "MAISY_KV.jpg", "refly": "ReFly_KV.jpg", "emekare": "EMEKARE_KV.jpg" },
    schedule: [{ "date": "2023-07-15", "events": ["", "", "m", ""], "farewell": ["", "", "MAISY"], "live": ["", "", "m"] }, { "date": "2023-07-16", "events": ["", "", "e", ""], "farewell": ["", "", "エメ☆カレ", ""], "live": ["", "", "e", ""] }, { "date": "2023-07-17", "events": ["", "", "r", ""], "farewell": ["", "", "Re:Fly"], "live": ["", "", "r"] }, { "date": "2023-07-18", "off": true }, { "date": "2023-07-19", "events": ["", "e", "", "r"], "present": ["", "1", "", "1"], "farewell": ["", "碧鳥・あずき・陽人・巴・志朗", "", "帝・立夏・宙・蓮・祭利"], "live": ["", "e", "", "r"] }, { "date": "2023-07-20", "events": ["", "m", "", ""], "present": ["", "1", "", ""], "farewell": ["", "新多・護・祈・千紘・荒木"], "live": ["", "m"] }, {
      "date": "2023-07-21", "events": ["", "r", "", "m"], "present": ["", "1", "", "1"], "farewell": ["", "帝・宙・コスモ・椿・優那", "", "優那・心・祈・陽人・杏"], "live": ["", "r", "", "m"]
    }, { "date": "2023-07-22", "events": ["e", "", "r", ""], "farewell": ["碧鳥・佐和・嵐真・千紘・巴", "", "立夏・志朗・コスモ・椿・蓮", ""], "live": ["e", "", "r"] }, {
      "date": "2023-07-23", "events": ["m", "", "e", ""], "farewell": ["新多・心・護・杏・嵐真", "", "佐和・あずき・陽人・巴・立夏", ""], "live": ["m", "", "e"]
    }, { "date": "2023-07-24", "off": true }, {
      "date": "2023-07-25", "events": ["", "m", "", "r"], "present": ["", "1", "", "1"], "farewell": ["", "新多・優那・祈・千紘・碧鳥", "", "帝・志朗・コスモ・荒木・護", ""], "live": ["", "m", "", "r"]
    }, {
      "date": "2023-07-26", "events": ["", "r", "", "e"], "present": ["", "1", "", "1"], "farewell": ["", "立夏・宙・コスモ・祭利・心", "", "碧鳥・佐和・あずき・嵐真・千紘"], "live": ["", "r", "", "e"]
    }, {
      "date": "2023-07-27", "events": ["", "e", "", ""], "present": ["", "1", "", ""], "farewell": ["", "佐和・陽人・嵐真・巴・帝"], "live": ["", "e"]
    }, {
      "date": "2023-07-28", "events": ["", "r", "", "m"], "present": ["", "1", "", "1"], "farewell": ["", "帝・立夏・宙・椿・新多", "", "優那・心・祈・杏・荒木"], "live": ["", "r", "", "m"]

    }, {
      "date": "2023-07-29", "events": ["e", "", "m", ""], "farewell": ["碧鳥・あずき・嵐真・志朗・宙", "", "新多・優那・護・千紘・杏", ""], "live": ["e", "", "m"]

    }, { "date": "2023-07-30", "events": ["r", "", "", ""], "farewell": ["立夏・志朗・コスモ・蓮・祭利"], "live": ["r"] }, { "date": "2023-07-31", "off": true }, {
      "date": "2023-08-01", "events": ["", "m", "", "r"], "present": ["", "1", "", ""], "farewell": ["", "心・護・祈・陽人・佐和", "", "帝・立夏・志朗・優那・祈"], "live": ["", "m", "", "r"]

    }, { "date": "2023-08-02", "events": ["", "e", "", ""], "present": ["", "1", "", ""], "farewell": ["", "碧鳥・佐和・陽人・巴・コスモ"], "live": ["", "e"] }, {
      "date": "2023-08-03", "events": ["", "m", "", "e"], "present": ["", "", "", "1"], "farewell": ["", "新多・心・護・千紘・荒木", "", "あずき・陽人・嵐真・帝・宙"], "live": ["", "m", "", "e"]

    }, {
      "date": "2023-08-04", "events": ["", "r", "", "m"], "farewell": ["", "志朗・宙・コスモ・椿・荒木", "", "新多・優那・祈・杏・あずき"], "live": ["", "r", "", "m"]

    }, {
      "date": "2023-08-05", "events": ["e", "", "m", ""], "farewell": ["碧鳥・佐和・あずき・嵐真・立夏", "", "MAISY"], "live": ["e", "", "m"]

    }, {
      "date": "2023-08-06", "events": ["e", "", "r", ""], "farewell": ["エメ☆カレ", "", "Re:Fly"], "live": ["e", "", "r"]
    }],
  },
  mutations: {
    setVisual(from, to) {
      this.state.fromImg = this.state.keyvisuals[from];
      this.state.toImg = this.state.keyvisuals[to];
    },
    getNews() {
      const http = axios.create({
        headers: { "Cache-Control": "no-cache" },
      });
      http.get("./mren/data/news.json").then(
        response => {
          if (response.data) {
            this.state.news = response.data.news;
            this.state.endtime = response.data.endtime;
            let nowdate = new Date().getTime() / 1000;
            // console.log([nowdate , this.state.endtime])
            if (
              nowdate > this.state.endtime
            ) {
              this.dispatch('getNewNews');
            }
            Vue.nextTick(() => {
              this.dispatch('setJs');
              // this.setPopup();
            });
          }
        }
      )
    },
    getNewNews() {
      const http = axios.create({
        headers: { "Cache-Control": "no-cache" },
      });
      http.post("../oan/cgi/news.cgi", {
        ch: "mre"
      }).then(
        response => {
          if (response.data) {
            this.state.news = response.data.news;
          }
        });
    },
    setJs() {
      $(".news-text a").on("click", function () {
        if ($(this).data('href')) {
          const y = window.scrollY;
          const goingTo = $($(this).data('href')).offset().top;
          const offsetTo = 50
          const toy = goingTo - offsetTo;
          const duration = toy > y ? (toy - y) / 4 + 200 : (y - toy) / 4 + 200;
          $("html, body").animate({ scrollTop: toy }, duration);
        } else {
          $(this).attr('target', '_blank');
        }
      });
    },
    setScroll() {
      $(".scroll").on("click", function () {
        const y = window.scrollY;
        const goingTo = $($(this).data('href')).offset().top;
        const offsetTo = 50
        const toy = goingTo - offsetTo;
        const duration = toy > y ? (toy - y) / 4 + 200 : (y - toy) / 4 + 200;
        $("html, body").animate({ scrollTop: toy }, duration);
      });
    },
    setChannel(state, channel) {
      state.channel = channel;
    }

  },
  actions: {
    getNewNews({ commit }) {
      commit('getNewNews');
    },
    setJs({ commit }) {
      commit('setJs');
    },
    setScroll({ commit }) {
      console.log('!')
      commit('setScroll');
    }
  },
  modules: {
  }
})
